import { render, staticRenderFns } from "./List.vue?vue&type=template&id=1a7c1704&scoped=true";
import script from "./List.vue?vue&type=script&lang=js";
export * from "./List.vue?vue&type=script&lang=js";
import style0 from "./List.vue?vue&type=style&index=0&id=1a7c1704&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "1a7c1704", null);
export default component.exports;